























































































































































































































































































































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import { PREFECTURES } from "@/consts/const";
import {
  PORTAL_JOBSEARCH_LISTING_OCCUPATION,
  PORTAL_JOBSEARCH_BUSINESS_DOMAIN,
  PORTAL_JOBSEARCH_RECRUITEE_WORK_EMPLOYMENT_TYPE,
} from "@/consts/portal";

@Component({
  components: {},
})
export default class extends Mixins(AxiosMixin, UtilMixin) {
  /** 初回ロード完了フラグ */
  private initLoadingDone = false;
  private item = null;
  private PREFECTURES = PREFECTURES;
  private PORTAL_JOBSEARCH_LISTING_OCCUPATION =
    PORTAL_JOBSEARCH_LISTING_OCCUPATION;
  private PORTAL_JOBSEARCH_BUSINESS_DOMAIN = PORTAL_JOBSEARCH_BUSINESS_DOMAIN;
  private PORTAL_JOBSEARCH_RECRUITEE_WORK_EMPLOYMENT_TYPE =
    PORTAL_JOBSEARCH_RECRUITEE_WORK_EMPLOYMENT_TYPE;

  public async created() {
    await this.fetchItem(Number(this.$route.params.id));
    this.initLoadingDone = true;
  }

  /** 契約情報取得 */
  private async fetchItem(id: number) {
    return new Promise((resolve) => {
      this.postJsonCheck(
        window.base_url + "/api/admin/portal_jobsearch_listing/get",
        { id: id },
        (res) => {
          this.item = res.data.listing;
          resolve(0);
        }
      );
    });
  }

  /** 事業所詳細ボタンクリック時 */
  private goOffice(id: number, ibow: boolean) {
    if (ibow) {
      this.$router.push({ path: `/portal/portal-office-ibow/detail/${id}` });
    } else {
      this.$router.push({ path: `/portal/portal-office-no-ibow/detail/${id}` });
    }
  }
}
